/* global __DEV__ */

export const uri = __DEV__
  ? 'https://mosty-gateway-dev-7txfdm6rba-uw.a.run.app/api/v1'
  : 'https://mosty-gateway-7txfdm6rba-uw.a.run.app/api/v1'
// : 'http://localhost:3000/api/v1'

export const uriV2 = __DEV__
  ? 'https://mosty-gateway-dev-7txfdm6rba-uw.a.run.app/api/v2'
  : 'https://mosty-gateway-7txfdm6rba-uw.a.run.app/api/v2'
  // : 'http://localhost:3000/api/v1'

export const adminPanelUri = __DEV__
  ? 'https://mosty-consultant-dev.now.sh'
  : 'https://admin.mosty.app'

export const auth = {
  waitingConfirmation: 5,
  user: 10,
  waitingConsultant: 25,
  consultant: 50,
  admin: 100
}

export const imageBaseURL = __DEV__
  ? 'https://mostydev.s3.us-west-2.amazonaws.com/'
  : 'https://mosty.s3.sa-east-1.amazonaws.com/'

export const supportPhone = '7194109636'
export const salesPhone = '11991361667'

export const supportEmail = 'suporte@mosty.com.br'

export const privacyPolicyURL = 'https://limaslab.gitlab.io/mosty/mosty-terms/politicas-de-privacidade'

export const instantProductsUpdateClients = __DEV__
  ? [655375]
  : [1002, 3712, 4327, 7950]

export const defaultEmail = __DEV__
  ? 'asdfasf@aldfjaksldjf.com'
  : ''

export const defaultPassword = __DEV__
  ? '123456'
  : ''

export const iuguAccountId = '5B27C6B0EFF43C1EE04F7E3F1838DD88'



// WEBPACK FOOTER //
// ./src/services/defaultProps.js